(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Chakram Dancer": {
      play: [
        {
          op: "grant",
          spec: { type: "unit", friendly: true, other: true, here: true },
          keyword: "shield",
          dur: "turn",
        },
      ],
    },

    "Downstage Dramatics": {
      play: [{ op: "draw", n: 1 }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Eclipse": {
      play: [buff("$t1", -4), { op: "predict", n: 1 }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give -4 Might to..." }],
    },

    "Gustwalker": {
      selfMightSpecs: [{ n: 1, cond: { k: "xp", n: 3 } }],
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "xp", n: 3 } }],
    },

    "Moonlight Affliction": {
      play: [buff("$t1", -10)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give -10 Might to..." }],
    },

    "Spectral Centaur": {
      triggers: [
        {
          on: "dies",
          optional: false,
          label: "When another friendly unit dies, give me +2 :rb_might: this turn",
          targets: [],
          program: [buff("source", 2)],
          friendlyUnit: true,
          condSpec: { k: "evSnapshotUnit" },
        },
      ],
    },

    "Sprite Burst": {
      play: [
        { op: "token", name: "Sprite", n: 2, loc: "base", exhausted: false, ready: true },
      ],
    },

    "Sprite Queen": {
      play: [
        { op: "token", name: "Sprite", n: 1, loc: "base", exhausted: false, ready: true },
      ],
      triggers: [
        {
          on: "beginningPhase",
          you: true,
          label: "When you play me or at the start of your Beginning Phase, play a ready 3 :rb_might: Sprite unit token with [Temporary] to your base",
          targets: [],
          program: [
            { op: "token", name: "Sprite", n: 1, loc: "base", exhausted: false, ready: true },
          ],
        },
      ],
    },

    "Scorn of the Moon": {
      legendAdd: { energy: 1, only: "showdown" },
    },

    "Moonfall": {
      targets: [
        {
          bind: "u",
          spec: { type: "unit", friendly: true, atBf: true },
          prompt: "Choose a battlefield where you have units (pick one of your units there)",
        },
        {
          bind: "e",
          spec: { type: "unit", enemy: true },
          min: 0,
          prompt: "You may move up to one enemy unit to that battlefield",
        },
      ],
      play: [
        {
          op: "if",
          cond: { k: "targetsChosen", bind: "e" },
          then: [{ op: "move", to: "$e", destRef: "$u" }],
        },
        {
          op: "grant",
          spec: { type: "unit", enemy: true, sameLocAs: "u", ignoreUntargetable: true },
          might: -2,
          dur: "turn",
        },
      ],
    },

    "Deceiver": {
      triggers: [
        {
          on: "conquer",
          you: true,
          optional: true,
          exhaustSelf: true,
          label: "conquer: discard and exhaust me for a Reflection",
          condSpec: { k: "selfReady" },
          program: [
            { op: "exhaust", to: "source" },
            { op: "discard", n: 1 },
            {
              op: "choose", bind: "c", min: 0,
              spec: { type: "unit", here: true },
              prompt: "The Reflection becomes a copy of which unit there?",
            },
            { op: "token", name: "Reflection", loc: "here", ready: true },
            {
              op: "grant", keyword: "temporary", dur: "perm",
              spec: { type: "unit", friendly: true, here: true, ready: true, maxMight: 0, ignoreUntargetable: true },
            },
            {
              op: "becomeCopy", from: "$c",
              spec: { type: "unit", friendly: true, here: true, ready: true, maxMight: 0, ignoreUntargetable: true },
            },
          ],
        },
        {
          on: "hold",
          you: true,
          optional: true,
          exhaustSelf: true,
          label: "hold: discard and exhaust me for a Reflection",
          condSpec: { k: "selfReady" },
          program: [
            { op: "exhaust", to: "source" },
            { op: "discard", n: 1 },
            {
              op: "choose", bind: "c", min: 0,
              spec: { type: "unit", here: true },
              prompt: "The Reflection becomes a copy of which unit there?",
            },
            { op: "token", name: "Reflection", loc: "here", ready: true },
            {
              op: "grant", keyword: "temporary", dur: "perm",
              spec: { type: "unit", friendly: true, here: true, ready: true, maxMight: 0, ignoreUntargetable: true },
            },
            {
              op: "becomeCopy", from: "$c",
              spec: { type: "unit", friendly: true, here: true, ready: true, maxMight: 0, ignoreUntargetable: true },
            },
          ],
        },
      ],
    },

    "Mirror Image": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "The Reflection becomes a copy of which unit?" }],
      play: [
        { op: "token", name: "Reflection", ready: true },
        {
          op: "grant", keyword: "temporary", dur: "perm",
          spec: { type: "unit", friendly: true, inBase: true, ready: true, maxMight: 0, ignoreUntargetable: true },
        },
        {
          op: "becomeCopy", from: "$t",
          spec: { type: "unit", friendly: true, inBase: true, ready: true, maxMight: 0, ignoreUntargetable: true },
        },
      ],
    },

    "Dramatic Visionary": {
      deathknell: [{ op: "predict", n: 2 }],
    },

    "Icevale Archer": {
      triggers: [
        {
          on: "attack",
          self: true,
          label: "pay 1 Energy: give a unit here -1 Might",
          program: [
            {
              op: "may",
              prompt: "Pay 1 Energy to give a unit here -1 Might this turn?",
              then: [
                {
                  op: "payCost",
                  cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
                  skipOnFail: 2,
                },
                {
                  op: "choose",
                  bind: "t",
                  spec: { type: "unit", here: true },
                  prompt: "Give which unit here -1 Might this turn?",
                },
                buff("$t", -1),
              ],
            },
          ],
        },
      ],
    },

    "Ruined Rex": {
      deathknell: [
        {
          op: "choose",
          bind: "t",
          spec: { type: "unit", enemy: true },
          prompt: "Deal 4 to which enemy unit?",
        },
        { op: "deal", to: "$t", n: 4 },
      ],
    },

    "Turn to Dust": {
      targets: [
        { bind: "t", spec: { type: "gear" }, prompt: "Give which gear [Temporary]?" },
      ],
      play: [{ op: "grant", to: "$t", keyword: "temporary", dur: "perm" }],
    },

    "Crescent Strike": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", enemy: true, atBf: true },
          prompt: "Deal 4 to which enemy unit at a battlefield?",
        },
      ],
      play: [
        { op: "deal", to: "$t", n: 4 },
        {
          op: "deal",
          spec: { type: "unit", enemy: true, sameLocAs: "t" },
          except: "t",
          n: 1,
        },
      ],
    },

    "Deadly Flourish": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", enemy: true },
          prompt: "Deal 3 to which enemy unit?",
        },
      ],
      play: [
        {
          op: "delayed", on: "dies", forEach: "$t", dur: "turn",
          label: "{target} died: play a Gold gear token exhausted",
          program: [{ op: "token", name: "Gold", n: 1, exhausted: true }],
        },
        { op: "deal", to: "$t", n: 3 },
      ],
    },

    "Keeper of Masks": {
      play: [
        { op: "token", name: "Reflection", n: 2, loc: "here", bind: "km" },
        { op: "becomeCopy", to: "$km", from: "source" },
      ],
    },

    "Petal Pixie": {
      selfMight: function (state, iid) {
        const Core = window.RB.Core;
        const o = state.objs[iid];
        if (!o || o.zone !== "board" || !o.loc || o.loc.t !== "bf") return 0;
        let n = 0;
        for (const other of Core.boardObjs(state)) {
          const oo = state.objs[other];
          if (oo.attachedTo) continue;
          if (oo.controller !== o.controller) continue;
          if (!Core.isType(state, other, "unit")) continue;
          if (!oo.loc || oo.loc.t !== "bf" || oo.loc.iid !== o.loc.iid) continue;
          if (!Core.hasKw(state, other, "temporary")) continue;
          n += 1;
        }
        return n;
      },
    },

    "Soul Shepherd": {
      auraMightSpecs: [
        { n: 1, who: "friendlyUnits", targetCond: { k: "selfToken" } },
      ],
    },

    "Sprite Fountain": {
      play: [{ op: "token", name: "Sprite", n: 1, ready: true }],
      deathknell: [{ op: "token", name: "Sprite", n: 1, ready: true }],
    },

    "Hwei, Brooding Painter": {
      triggers: [
        {
          on: "move",
          self: true,
          label: "draw 1, discard 1, then a bonus by the discarded card's type",
          program: [
            { op: "draw", n: 1 },
            { op: "discard", n: 1, bind: "d" },
            {
              op: "if",
              cond: { k: "targetType", bind: "d", type: "spell" },
              then: [{ op: "draw", n: 1 }],
            },
            {
              op: "if",
              cond: { k: "targetType", bind: "d", type: "gear" },
              then: [{ op: "readyRunes", n: 2 }],
            },
            {
              op: "if",
              cond: { k: "targetType", bind: "d", type: "unit" },
              then: [buff("source", 3)],
            },
          ],
        },
      ],
    },

    "Sumpworks Map": {
      triggers: [
        {
          on: "conquer",
          label: "opponent conquers: draw 1",
          condSpec: { k: "not", cond: { k: "evYou" } },
          program: [{ op: "draw", n: 1 }],
        },
        {
          on: "hold",
          label: "opponent holds: draw 1",
          condSpec: { k: "not", cond: { k: "evYou" } },
          program: [{ op: "draw", n: 1 }],
        },
        {
          on: "scored",
          label: "opponent scores: draw 1",
          condSpec: { k: "not", cond: { k: "evYou" } },
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Blue Sentinel": {
      holdAgainHere: 1,
      triggers: [
        {
          on: "unitHold",
          self: true,
          label: "Add 1 rainbow at the start of your next Main Phase",
          program: [
            {
              op: "delayed",
              on: "mainPhase",
              forPlayer: "controller",
              label: "Blue Sentinel: Add 1 rainbow",
              program: [{ op: "addResources", res: { anyPower: 1 } }],
            },
          ],
        },
      ],
    },

    "Gutter Palace": {
      triggers: [
        {
          on: "beginningPhase",
          you: true,
          label: "4 cards in hand and 4 units at battlefields: win the game",
          condSpec: {
            k: "and",
            conds: [
              { k: "count", spec: { zone: "hand" }, n: 4, cmp: "exactly" },
              {
                k: "count",
                spec: { type: "unit", friendly: true, atBf: true },
                n: 4,
                cmp: "exactly",
              },
            ],
          },
          program: [{ op: "winGame", how: "Gutter Palace" }],
        },
      ],
      abilities: [
        {
          label: "Discard 1, exhaust: play a Bird token",
          exhausts: true,
          costDiscard: 1,
          targets: [],
          program: [{ op: "token", name: "Bird", n: 1 }],
        },
      ],
    },

    "Jhin, Meticulous Killer": {
      addCosts: [
        {
          optional: true,
          cond: { k: "spellSpentAtLeast", n: 4 },
          label: "Jhin, Meticulous Killer",
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["mind"] },
          discount: { energy: 4, pips: 0, anyPower: 0, domains: null },
        },
      ],
    },

    "LeBlanc, Everywhere at Once": {
      suppressTemporaryHere: true,
    },

    "Zilean, Time Mage": {
      tokenDoubler: { oncePerTurn: true, requiresAtBf: true },
    },

    "Fate Weaver": {
      play: [{
        op: "lookTopTake", n: 4, optional: true, public: true, take: "hand",
        filter: { type: "spell", minEnergy: 4 },
        prompt: "Reveal a spell costing 4 or more and draw it (choose none to recycle all 4)",
      }],
    },

    "Frigid Jewel": {
      triggers: [{
        on: "draw", you: true, oncePerTurn: true,
        label: "your second card drawn this turn: give a friendly unit +2 Might",
        condSpec: { k: "turnFact", key: "drawn", n: 2 },
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true },
          prompt: "Give which friendly unit +2 Might this turn?",
        }],
        program: [buff("$t", 2)],
      }],
    },

    "Diana, Lunari": {
      triggers: [{
        on: "showdownStart", selfBf: true, optional: true,
        label: "showdown here: pay 1 to Predict and draw a revealed spell",
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 2 },
          { op: "predict", n: 1 },
          {
            op: "lookTopTake", n: 1, public: true, take: "hand", restTo: "top",
            filter: { type: "spell" },
            prompt: "Draw the revealed spell",
          },
        ],
      }],
    },

    "Lillia, Fae Fawn": {
      triggers: [{
        on: "move", self: true,
        label: "I move from a location: play a Sprite token there",
        program: [{ op: "token", name: "Sprite", n: 1, loc: "evFrom" }],
      }],
    },

    "Smoke and Mirrors": {
      targets: [
        {
          bind: "a", spec: { type: "unit", friendly: true },
          prompt: "Choose a unit you control",
        },
        {
          bind: "b", spec: { type: "unit", friendly: true, notSameLocAs: "a", notBind: "a" },
          prompt: "Choose another unit you control at a different location",
        },
      ],
      play: [
        {
          op: "if",
          cond: {
            k: "or",
            conds: [
              { k: "targetKw", bind: "a", kw: "temporary" },
              { k: "targetKw", bind: "b", kw: "temporary" },
            ],
          },
          then: [{ op: "swapLoc", a: "$a", b: "$b" }],
        },
        { op: "draw", n: 1 },
      ],
    },
  });
})();
